<template>
  <div v-if="agent">
    <!-- title -->
    <p class="title is-4 is-spaced">{{ agent.username }}</p>
    <p class="subtitle is-5">
      <span v-for="balance in agent.balances" :class="{'has-text-success': balance.isActive}">
        {{balance.real | currency(balance.currency)}}
        <description :obj="balance"/>
      </span>
    </p>

    <!-- tabs -->
    <div class="tabs is-boxed">
      <ul>
        <router-link :to="{ name: 'agent' }" active-class="is-active" tag="li" exact><a>General</a></router-link>
      </ul>
    </div>

    <router-view />
  </div>
</template>
<script>
  import state from '../../../../../state'
  import agentService from '../../../../../services/agent.service'
  import breadcrumbsService from '../../../../../services/breadcrumbs.service'

  import description from '../../../../common/description.vue'

  export default {
    name: 'agent',
    components: { description },
    computed: {
      agentId() {
        return this.$route.params.agentId;
      },
      agent() {
        return state.editAgent.get();
      }
    },
    async mounted() {
      await agentService.load(this.agentId);
      breadcrumbsService.dynamic.set({ key: "agent", func: () => this.agent.username });
    },
    beforeDestroy() {
      state.editAgent.unset();
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/agents/agent/index.vue